/**
 * @module kryo/writers/json
 */
import { JsonValueWriter } from "./json-value-writer.mjs";
export class JsonWriter {
  /**
   * Creates a new JSON writer.
   *
   * @param pretty If `true`, indent with 2 spaces and add a final new line.
   */
  constructor(pretty = false) {
    this.valueWriter = new JsonValueWriter();
    this.pretty = pretty;
  }
  writeAny(value) {
    return this.stringify(this.valueWriter.writeAny(value));
  }
  writeBoolean(value) {
    return this.stringify(this.valueWriter.writeBoolean(value));
  }
  writeBytes(value) {
    return this.stringify(this.valueWriter.writeBytes(value));
  }
  writeDate(value) {
    return this.stringify(this.valueWriter.writeDate(value));
  }
  writeRecord(keys, handler) {
    return this.stringify(this.valueWriter.writeRecord(keys, handler));
  }
  writeFloat64(value) {
    return this.stringify(this.valueWriter.writeFloat64(value));
  }
  writeList(size, handler) {
    return this.stringify(this.valueWriter.writeList(size, handler));
  }
  writeMap(size, keyHandler, valueHandler) {
    return this.stringify(this.valueWriter.writeMap(size, keyHandler, valueHandler));
  }
  writeNull() {
    return this.stringify(this.valueWriter.writeNull());
  }
  writeString(value) {
    return this.stringify(this.valueWriter.writeString(value));
  }
  stringify(jsonValue) {
    if (!this.pretty) {
      return JSON.stringify(jsonValue);
    } else {
      return `${JSON.stringify(jsonValue, null, 2)}\n`;
    }
  }
}
export const JSON_WRITER = new JsonWriter(false);
export const PRETTY_JSON_WRITER = new JsonWriter(true);
